import { Col, Radio, Row, Select, Typography } from "antd";
import { useEffect, useState } from "react";
import { getSizingDetailsByPK } from "apis";
import "./procurementCSS.css";

const { Text } = Typography;
const OVERRIDE_VALUE = "__override__";

const ClusterCandidates = ({ candidates, handleCandidateChange, clusterSizeOptions = [] }) => {

    const [selectedValue, setSelectedValue] = useState(null);
    const [overrideSize, setOverrideSize] = useState(null);
    const [overrideOptions, setOverrideOptions] = useState([]);

    useEffect(() => {
        const fetchOverrideOptions = async () => {
            try {
                const response = await getSizingDetailsByPK();
                if (response.success && Array.isArray(response.data)) {
                    const sorted = response.data.sort((a, b) => {
                        const numA = parseInt(a.SK?.match(/^\d+/)?.[0] || "0", 10);
                        const numB = parseInt(b.SK?.match(/^\d+/)?.[0] || "0", 10);
                        return numA - numB;
                    });
                    setOverrideOptions(sorted);
                }
                
            } catch (e) {
                console.error("Error fetching override sizing options:", e);
            }
        };
        fetchOverrideOptions();
    }, []);

    const onRadioChange = (e) => {
        const value = e.target.value;
        setSelectedValue(value);
        if (value !== OVERRIDE_VALUE) {
            setOverrideSize(null);
            handleCandidateChange?.(value);
        } else {
            handleCandidateChange?.(overrideSize);
        }
    };

    const onOverrideDropdownChange = (value) => {
        setOverrideSize(value);
        handleCandidateChange?.(value);
    };

    if (!candidates || candidates.length === 0) {
        return null;
    }

    return (
        <div className="cluster-candidates-container">
            <Text strong style={{ fontSize: 14, color: "#374151", marginBottom: 8, display: "block" }}>
                Recommended T-Shirt Sizes
            </Text>
            <Radio.Group
                className="cluster-candidates-radio"
                value={selectedValue}
                onChange={onRadioChange}
                style={{ width: "100%" }}
            >
                <Row gutter={[12, 12]}>
                    {candidates.map((item) => (
                        <Col span={24} key={item.tshirt_size}>
                            <div className={`candidate-option ${selectedValue === item.tshirt_size ? "candidate-option-selected" : ""}`}>
                                <Radio value={item.tshirt_size}>
                                    <span className="candidate-label">
                                        <Text strong style={{ color: "#1F2937" }}>{item.title}</Text>
                                        <Text type="secondary" style={{ marginLeft: 8 }}>{item.tshirt_size}</Text>
                                    </span>
                                </Radio>
                            </div>
                        </Col>
                    ))}
                    <Col span={24}>
                        <div className={`candidate-option ${selectedValue === OVERRIDE_VALUE ? "candidate-option-selected" : ""}`}>
                            <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
                                <Radio value={OVERRIDE_VALUE}>
                                    <Text strong style={{ color: "#1F2937" }}>Override</Text>
                                </Radio>
                                <Select
                                    virtual={false}
                                    options={overrideOptions.map((item) => ({
                                        label: item?.["SK"],
                                        value: item?.["SK"],
                                    }))}
                                    style={{ minWidth: 280, flex: 1, maxWidth: 400 }}
                                    placeholder="Select a T-Shirt size"
                                    value={overrideSize}
                                    onChange={onOverrideDropdownChange}
                                    disabled={selectedValue !== OVERRIDE_VALUE}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Radio.Group>
        </div>
    );
};

export default ClusterCandidates;
